var AjaxForms = {

    options : {
        target      : null,
        successFn   : null,
        errorFn     : null,
        method      : 'POST',
        recaptcha   : false
    },
 
    init:function(t){
        var $this = this;
        var $form = $(t);
        if( $this.recaptcha ===  true || $this.options.recaptcha ===  true){
            $.ajax({
                url: 'https://www.google.com/recaptcha/api.js?render=' + $form.find('.g-recaptcha').data('sitekey'),
                dataType: "script",
                success:function(){}
            });
        } 
        $this.options.target = t;
        $($this.options.target).parsley(
            {
                excluded: "input:hidden,select:hidden"
            }
        );
        $($this.options.target).on('submit',function($e){

            if($form.find('input[name=payment_method]').length > 0 && $form.find('input[name=payment_method]:checked').val() == 'credit_card' ){
                $valid_card = true;
                if($form.find('input[name=card_number]').length > 0){
                    $form.find('input[name=card_number]').validateCreditCard(function(result) {                                               
                        if(!result.valid){                    
                            post_id = false;
                            actionResponseModal('Invalid Card Number','error','.actions-block .save');   
                            $valid_card = false;
                        }
                        $e.preventDefault();    
                    });
               
                
                    $form.find('input[name=card_number]').off('input.jccv keyup.jccv');
                    var $exp_date_year = Number( "20"+$form.find('select[name=exp_date_year]').val() );
                    var $exp_date_month = Number( $form.find('select[name=exp_date_month]').val() );
                    var $date = new Date();


                    if($exp_date_year < $date.getFullYear()){
                        $valid_card = false;
                        actionResponseModal('Card Expired','error','.actions-block .save');   
                    }else if($exp_date_year == $date.getFullYear()){
                        if($exp_date_month < $date.getMonth()+1){
                            $valid_card = false;
                            actionResponseModal('Card Expired','error','.actions-block .save');   
                        }
                    }
                }else{
                    $valid_card = true;
                }
                if($valid_card){
                    $this.submit_form($e);                        
                }  

            }else{
                $this.submit_form($e);
            }
            $e.preventDefault();    
        }).addClass('ready'); 
    },
    form_submit_response : function(msg , type){
        actionResponseModal(msg,type);
    },
    
    submit_form:function($e){

        var $this       = this,
            $form       = $($this.options.target),
            successFn   = $this.options.successFn,
            errorFn     = $this.options.errorFn,
            url         = $form.attr('action'),
            postData    = $form.serialize(),
            method      = $this.options.method || 'POST',
            $submitBTN  = $form.find('button[type="submit"]');
            

        $submitBTN.prop('disabled',true);
        $submitBTN.data('initialText',$submitBTN.text());
        $submitBTN.html('<i class="fa fa-spinner fa-spin"></i> '+LOCALE['working on it']);        
        $.ajax({
            url     : url,
            data    : postData,
            method  : method,
            success: function (data) {

                if($this.recaptcha ===  true){
                    grecaptcha.execute();
                    grecaptcha.reset();
                }
                $submitBTN.text(data.message);

                setTimeout(function(){
                    $submitBTN.text($submitBTN.data('initialText'));
                },3000);

                $submitBTN.prop('disabled',false);

                if(data.status && data.status == 'error'){
                    $this.form_submit_response(data.message,'error');
                }else{
                    $form.find('input,textarea,select').not(':hidden').each(function(){
                        $(this).removeClass('parsley-success');
                    });

                    if(typeof(successFn) !== 'undefined'){
                        successFn(data);
                    }else{
                        $this.form_submit_response(data.message || 'submitted','success');
                    }
                }

                /*
                if (url == '/api/checkout-step') {
                    const checkoutStep = $form.find('input[name="step"]').val();

                    if (checkoutStep == 'confirm') {
                        var dlTotal = 0;
                        var dlTtax = 0;
                        var dlShipping = 0;
                        var dlProducts = [];
                        var dlCoupon = '';
                        
                        if ($('#dl-cart-total').length) {
                            dlTotal = Number($('#dl-cart-total').val());
                        }
                        
                        if ($('#dl-cart-tax').length) {
                            dlTtax = Number($('#dl-cart-tax').val());
                        }
                        
                        if ($('#dl-cart-shipping').length) {
                            dlShipping = Number($('#dl-cart-shipping').val());
                        }
                        
                        if ($('#dl-products-list').length) {
                            dlProducts = JSON.parse($('#dl-products-list').val());
                        }
                        
                        dataLayer.push({
                            event: "purchase",
                            transaction_id: data.order_id,
                            currency: "USD",
                            value: dlTotal,
                            tax: dlTtax,
                            shipping: dlShipping,
                            coupon: dlCoupon,
                            items: dlProducts
                        });
                    }
                }
                */
            },
            error: function (response) {
                if($this.recaptcha ===  true){
                    grecaptcha.execute();
                    grecaptcha.reset();
                }
                $submitBTN.text($submitBTN.data('initialText'));

                $submitBTN.prop('disabled',false);

                //errors
                var responseJSON = jQuery.parseJSON(response.responseText);
                if( typeof responseJSON.errors !== "undefined" ){
                    responseJSON = responseJSON.errors;
                }

                if(errorFn !== null && typeof(errorFn) == 'function'){
                    errorFn( responseJSON );
                }else{
                   for(var i in responseJSON){
                        var t = $form.find('input[name="'+i+'"]').closest('.form-group');
                        t.find('input').addClass('parsley-error');

                        if(t.find('.parsley-errors-list').length > 0){

                            if(typeof responseJSON[i] === 'string'){
                                t.find('.parsley-errors-list').html('<li class="parsley-type">'+responseJSON[i]+'</li>');
                            }else{
                                t.find('.parsley-errors-list').html('<li class="parsley-type">'+responseJSON[i].join('')+'</li>');    
                            }                            
                        }else{
                            if(typeof responseJSON[i] === 'string'){
                                t.append('<ul class="parsley-errors-list filled"><li class="parsley-type">'+responseJSON[i]+'</li></ul>');
                            }else{
                                t.append('<ul class="parsley-errors-list filled"><li class="parsley-type">'+responseJSON[i].join('')+'</li></ul>');
                            }
                        }
                    }
                }
            }

        }); 
    }
}


var ContactForm = $.extend({}, AjaxForms , { 
        options:{
        api_route : 'contact', 
        recaptcha : true,
        successFn:function(data){            
            actionResponseModal(data.message || 'submitted','success');
            setTimeout(function(){
                window.location.reload();
            },2000);
            
        }
    }
});







var Newsletter	                = $.extend({}, AjaxForms , {options:{api_route : 'api/newsletter'}});

var AddReview             	    = $.extend({}, AjaxForms , {options:{api_route : 'api/add-review',successFn:function(){
    load_partial($('.reviews-partial'));
}}});


var AddUserVehicle              = $.extend({}, AjaxForms , {options:{api_route : 'api/add-user-vehicle',successFn:function(){window.location.reload();}}});

var CloseAccountForm    	    = $.extend({}, AjaxForms , {options:{api_route : 'api/close-account'}});
//var CloseUserAccountForm        = $.extend({}, AjaxForms , {options:{api_route : 'api/close-user-account',successFn:function(){window.location.reload();}}});
//var UpdateUserAccountForm       = $.extend({}, AjaxForms , {options:{api_route : 'api/update-user-account',successFn:function(){}}});



var CheckoutStep1               = $.extend({}, AjaxForms , {options:{
    api_route : 'api/checkout-step',
    successFn:function(data){CheckOutStep(data);},
    errorFn:function(data){
        actionResponseModal(data.message,'error');
    }
}});
var CheckoutStep2               = $.extend({}, AjaxForms , {options:{api_route : 'api/checkout-step',successFn:function(data){CheckOutStep(data);}}});
var CheckoutStep3               = $.extend({}, AjaxForms , {options:{api_route : 'api/checkout-step',successFn:function(data){CheckOutStep(data);}}});

var PlaceOrder                  = $.extend({}, AjaxForms , {options:{api_route : 'api/checkout-step',successFn:function(data){CheckOutStep(data);}}});


var ChangePasswordForm      = $.extend({}, AjaxForms , {options:{api_route : 'api/update-password'}});
var ForgotPasswordForm      = $.extend({}, AjaxForms , {options:{api_route : 'api/forgot_password'}});

var ProfileForm                 = $.extend({}, AjaxForms , {options:{api_route : 'api/update-profile'}});
var ProfileFormBillingAddress   = $.extend({}, AjaxForms , {options:{api_route : 'api/update-profile'}});
var ProfileFormShippingAddress  = $.extend({}, AjaxForms , {options:{api_route : 'api/update-profile'}});
var vehiclesForm                = $.extend({}, AjaxForms , {options:{api_route : 'api/vehicles-form'}});



var CompanyForm         = $.extend({}, AjaxForms , {options:{api_route : 'api/update-company-info'}});
var CompanyAddressForm  = $.extend({}, AjaxForms , {options:{api_route : 'api/update-company-address'}});




/*
$(function(){
	$('form#newsletter_form').submit(function(){
		$('.newsletter-form .email-prefs').addClass('show-prefs');	
		$('.newsletter-form .animate').addClass('shown');	
		fitmentSearch.init('footer');
		NewsletterEmailPrefs.init('#emailprefs_form');
	});
	$('.newsletter-form .email-prefs .close_prefs').click(function(){
		$('.newsletter-form .email-prefs').removeClass('show-prefs');		
		$('.newsletter-form .animate').removeClass('shown');	
		return false;
	});
});*/
function sendFeedback($this,$feed){
	var $form = $this.parent();
	$form.find('input[name="feedback" ]').val($feed);

	 $.ajax({
		url: $form.attr('action'),
		data: $form.serialize(),
		success: function (data) {
			if (data.status === "ok") {
				actionResponseModal(data.message,'success');
			} else if (data.status === 'error') {
				actionResponseModal(data.message,'error');
			} else {
				actionResponseModal(LOCALE.general_error,'error');
			}
		}
	 });
}
